{
  "docs": [
    "docs/APPLICATIONS.md",
    "docs/CATEGORICAL_REIFICATIONS.md",
    "docs/CLOSURE_AUDIT.md",
    "docs/CONTRASTS.md",
    "docs/DEEP_THEORY.md",
    "docs/DIFFERENTIAL_SECURITY_APPLICATIONS.md",
    "docs/OPERATOR_PLAYBOOK.md",
    "docs/PROMOTION_AS_MORPHISMS.md",
    "docs/PROMOTION_LOOP_CLOSED.md",
    "docs/PROOF_TREES_AS_BOP_EVIDENCE.md",
    "docs/PROOF_TREE_INTEGRATION.md",
    "docs/THREAT_MODEL_AND_CLAIMS.md",
    "docs/WHAT_IF_SIMULATOR.md"
  ],
  "entrypoints": [
    ".venv/bin/python runtime/run_baseline_demo.py",
    ".venv/bin/python runtime/run_csk_demo_regime3.py",
    ".venv/bin/python runtime/run_csk_demo_regime2.py",
    ".venv/bin/python runtime/make_approval_witness.py",
    ".venv/bin/python tests/test_demo.py",
    ".venv/bin/python runtime/run_csk_demo_regime3_trusted.py",
    ".venv/bin/python tooling/compute_footprint.py",
    ".venv/bin/python runtime/run_csk_demo_override.py",
    ".venv/bin/python runtime/make_superuser_override.py",
    "cd ui && npm install && npm run dev",
    ".venv/bin/python tooling/check_regime.py policies/regime-3.json",
    ".venv/bin/python tooling/verify_ledger.py",
    ".venv/bin/python tooling/explain_receipt.py receipts/<some-receipt>.json",
    ".venv/bin/python tooling/build_proof_tree.py receipts/<receipt>.json outputs/csk/proof-tree.json",
    ".venv/bin/python tooling/propose_delta.py ui/public/data/snapshots/baseline-safe ui/public/data/snapshots/with-override operator.demo",
    ".venv/bin/python tooling/synthesize_policy.py policies/regions/region-r3.json > policies/SYNTH_region-r3.json",
    ".venv/bin/python tooling/promotion_pipeline.py list",
    ".venv/bin/python tooling/matrix_closure_audit.py matrix/bridge-matrix.json"
  ],
  "exploit": "Prompt injection -> HTTP exfiltration",
  "features": [
    "trusted domain allowlist (policy eval)",
    "human approval witness flow (regime2)",
    "monotone budget spend ledger + receipt",
    "bridge interaction matrix sequence evaluation",
    "append-only receipt hash chain ledger (BOP pin)",
    "regime3 safe execution demo",
    "bridge footprint artifact emission",
    "explicit missing-bridge artifact and refusal receipts cite forbidden_shape_id + missing_bridge_id",
    "differential delta experiment: override regime admitting missing bridge under superuser witness",
    "deep analysis docs: applications, contrasts with existing frameworks, differential security ops playbook",
    "React+Vite+Tailwind UI visualizer (local-only, static JSON)",
    "UI upgrades: matrix graph, threat model claims panel; tooling: regime checker + ledger verifier; theory: threat model & operator playbook",
    "UI: path explorer (allowed path search)",
    "UI: δ-diff viewer (bridge/matrix/footprint deltas)",
    "Tooling: sync_ui_data + delta_diff scripts",
    "Theory: deep GovExt/δ mapping doc",
    "UI: regime region visualization (count-space demo)",
    "UI: receipt explainer panel",
    "Tooling: explain_receipt CLI",
    "UI: proof-tree explainer tab (BOP predicate trace)",
    "Tooling: build_proof_tree.py from receipt",
    "Theory: proof trees as BOP evidence note",
    "UI: proof-tree → path explorer jump",
    "UI: regime cone visualizer with constraint violations",
    "Docs: proof-tree integration note",
    "UI: client-side proof tree built from receipt (no CLI needed)",
    "UI: what-if simulator (δ and matrix edits)",
    "Docs: what-if simulator note",
    "Docs: contrasts extended to policy engines (OPA/Cedar)",
    "Tooling: propose_delta.py generates signed δ-change proposal artifacts",
    "Tooling: synthesize_policy.py (toy γ) from region constraints",
    "UI: proposals viewer for δ-change requests",
    "Docs: categorical reifications + diagrams",
    "Tooling: promotion_pipeline.py (review/accept/apply gates)",
    "Tooling: matrix_closure_audit.py (reachability audit)",
    "UI: audit tab showing closure audit findings",
    "Docs: promotion as morphisms note",
    "Promotion pipeline apply materializes new UI snapshot + regenerates δ-diff + footprint",
    "Matrix closure audit supports configurable probes",
    "UI: snapshots tab"
  ],
  "name": "CSK-AGENT-TOOL-EXECUTION-SPINOUT",
  "version": "1.7.0"
}
